import React from 'react'

import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { PlusInCircle } from '@surglogs-app/icons'

import { FlexBox } from '../FlexBox'
import { Icon } from '../Icon'
import { Text } from '../Text'

export const SelectOption = styled(FlexBox)<{
  isSelected?: boolean
  disabled?: boolean
  isCreateNewOption?: boolean
}>`
  flex: 1;
  align-items: center;
  min-height: ${({ theme }) => theme.ui.spacings.xxl};
  // because icon is 24px high
  padding-block: ${({ theme }) => theme.ui.spacings['abs.12']};
  padding-inline: ${({ theme }) => theme.ui.spacings.md};
  color: ${({ theme, isSelected }) =>
    isSelected ? theme.ui.colors['blue.100'] : theme.ui.colors['navy.100']};
  font-size: ${({ theme }) => theme.ui.typography.fontSizes.sm};
  line-height: ${({ theme }) => theme.ui.typography.lineHeights.sm};
  justify-content: ${({ jc }) => jc ?? 'space-between'};
  border-radius: 0;
  cursor: default;

  ${({ theme, disabled }) =>
    !disabled &&
    css`
      cursor: pointer;
      &:hover {
        background-color: ${theme.ui.colors['blue.100']};
        color: ${theme.ui.colors['white.100']};
      }
    `};

  ${({ theme, isCreateNewOption }) =>
    isCreateNewOption &&
    css`
      border-top: 1px solid ${theme.ui.colors['navy.25']};
      margin-top: -1px;
    `};
`

interface CreatedSelectOptionProps {
  createOptionLabel: string
  value: string
}

export const CreatedSelectOption = ({
  createOptionLabel,
  value,
}: CreatedSelectOptionProps) => {
  return (
    <FlexBox
      {...{
        ai: 'center',
        gap: 'sm',
        'aria-label': 'create-new-option',
      }}>
      <Icon {...{ icon: PlusInCircle, color: 'inherit' }} />
      <FlexBox {...{ fd: 'column', gap: 'xxs' }}>
        <Text {...{ color: 'inherit' }}>{value}</Text>
        <Text {...{ size: 'xxs', color: 'inherit' }}>{createOptionLabel}</Text>
      </FlexBox>
    </FlexBox>
  )
}
